<template>
  <button @click="addObject" class="mk-object-button">
    {{object.title}}
    <img
      v-if="object.image"
      class="mk-object-button__image"
      :src="require(`@/assets/images/objects/${object.image}`)"
    />
    <div v-if="
      object.type === 'standard-glass'
      || object.type === 'extension-glass'
      || object.type === 'stand'
    ">
      {{valueInMetric}}{{metric ? 'mm' : 'inch'}}
    </div>
    <div
      v-if="object.type === 'standard-glass' || object.type === 'extension-glass'"
      class="mk-object-button__glass"
      :style="{width: `${object.width * 30}px`}"
    >
      <div v-if="object.cutout" class="mk-object-button__glass__cutout"/>
    </div>

    <div
      v-if="object.type === 'stand'"
      class="mk-object-button__glass mk-object-button__glass--stand"
      :style="{width: `${object.length * 60}px`}"
    />
  </button>
</template>

<script>
/**
 * Object Button
 * @author David <david.prenninger@gmx.de>
 *
 * This componet is a generic representation of an option of the ObjectSelectionPopup.
 * It shows an image or grafic representation depending on product type.
 */
export default {
  props: {
    object: Object,
    closeCallback: Function,
  },
  computed: {
    metric() {
      return this.$store.getters.metric;
    },
    // Returns the value in mm or inch. (The original mm factor is 1/500)
    valueInMetric() {
      if (this.object.type === 'stand') {
        if (this.metric) {
          return Math.floor(this.object.length * 500);
        }
        return Number(((this.object.length * 500) / 25.4).toFixed(1));
      }
      if (this.metric) {
        return Math.floor(this.object.width * 500);
      }
      return Number(((this.object.width * 500) / 25.4).toFixed(1));
    },
  },
  methods: {
    addObject() {
      this.closeCallback(this.object);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-object-button {
  box-shadow: $bs_md;
  padding: 10px;
  height: 130px;
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: $br_md;
  background-color: transparent;
  border: none;
  margin: 5px 0;

  &__image {
    height: 50px;
  }

  &__glass {
    position: relative;
    height: 100px;
    background-color: $c_glass;

    &--stand {
      margin: 5px 0;
      height: 30px;
      border-top-left-radius: $br_md;
      border-top-right-radius: $br_md;
    }

    &__cutout {
      position: absolute;
      width: 20px;
      bottom: -5px;
      left: calc( 50% - 10px);
      height: 20px;
      background-color: $c_white;
      border-radius: $br_md;
    }
  }
}
</style>
